<template>
  <div>
    <h2>Merit Incentive Fund Configuration</h2>
    <div class="card">
      <div class="card-header">
        Merit Incentive Fund Phases
      </div>
      <div class="card-body">
        <table class="table table-bordered">
          <tr>
            <th style="width: 50%">
              Phase
            </th>
            <th style="width: 25%">
              Last Updated
            </th>
            <th style="width: 25%">
              Updated By
            </th>
          </tr>
          <tr>
            <td>
              <b-form-group>
                <b-form-checkbox v-model="phase1Toggle" switch @change="toggleChanged('phase1')">
                  Phase 1 Data Entry Enabled
                </b-form-checkbox>
              </b-form-group>
            </td>
            <td>{{ formatDate(getToggle('phase1').lastUpdated) }}</td>
            <td>{{ getToggle('phase1').updatedBy }}</td>
          </tr>
          <tr>
            <td>
              <b-form-group>
                <b-form-checkbox v-model="phase2Toggle" switch @change="toggleChanged('phase2')">
                  Phase 2 Data Entry Enabled
                </b-form-checkbox>
              </b-form-group>
            </td>
            <td>{{ formatDate(getToggle('phase2').lastUpdated) }}</td>
            <td>{{ getToggle('phase2').updatedBy }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      phase1Toggle: false,
      phase2Toggle: false,
      toggles: [
        { key: 'phase1', isEnabled: false, lastUpdated: null, updatedBy: null },
        { key: 'phase2', isEnabled: false, lastUpdated: null, updatedBy: null }
      ]
    }
  },
  async mounted() {
    await this.refreshData()
  },
  methods: {
    async refreshData() {
      try {
        const res = await fetch('/api/merit-incentive/config');
        if (!res.ok) throw new Error('Failed to fetch phase config');
        const data = await res.json();
        // API returns PhaseConfigurations object
        debugger;
        this.phase1Toggle = !data.meritIncentivePhase1Disabled;
        this.phase2Toggle = !data.meritIncentivePhase2Disabled;
        this.toggles = [
          { key: 'phase1', isEnabled: this.phase1Toggle, lastUpdated: data.phase1LastUpdated, updatedBy: data.phase1LastUpdatedBy },
          { key: 'phase2', isEnabled: this.phase2Toggle, lastUpdated: data.phase2LastUpdated, updatedBy: data.phase2LastUpdatedBy }
        ];
      } catch (e) {
        // fallback: keep toggles as-is
      }
    },
    async toggleChanged(key) {
      try {
        console.log('Toggled:', key, 'New Value:', this[key + 'Toggle']);
        // Use the toggled value (already updated by v-model)
        const body = {
          MeritIncentivePhase1Disabled: !this.phase1Toggle,
          MeritIncentivePhase2Disabled: !this.phase2Toggle,
        };
        const res = await fetch('/api/merit-incentive/config', {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
        if (!res.ok) throw new Error('Failed to update phase config');
      } catch (e) {
        await this.refreshData();
      }
    },
    getToggle(key) {
      return this.toggles.find(t => t.key === key) || { lastUpdated: null, updatedBy: null }
    },
    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleString()
    }
  }
}
</script>

<style scoped>
</style>
